import React from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Paper, Typography, Box } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const SuccessPage = () => {
  const location = useLocation();
  const email = location.state?.email || '';
  const paymentOrSubscription = location.state?.paymentOrSubscription || '';

  return (
    <Container maxWidth="sm" sx={{ px: { xs: 2, sm: 3 } }}>
      <Box sx={{ mt: { xs: 2, sm: 4 }, mb: { xs: 2, sm: 4 } }}>
        <Paper elevation={3} sx={{ p: { xs: 2, sm: 3, md: 4 }, textAlign: 'center' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
            <img 
              src="/logo.jpeg" 
              alt="FCO Coaching" 
              style={{ 
                maxWidth: '200px', 
                width: '100%', 
                height: 'auto',
                borderRadius: '8px'
              }} 
            />
          </Box>
          
          <CheckCircleOutlineIcon 
            sx={{ fontSize: { xs: 60, sm: 80 }, color: 'success.main', mb: 2 }} 
          />
          
          <Typography variant="h4" gutterBottom color="success.main" sx={{ fontWeight: 'bold', fontSize: { xs: '1.5rem', sm: '2rem', md: '2.125rem' } }}>
            ¡Solicitud exitosa!
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3, fontSize: { xs: '1rem', sm: '1.25rem' } }}>
            Revisa tu correo electrónico:
          </Typography>
          
          <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: 'primary.main', fontSize: { xs: '1.25rem', sm: '1.5rem' }, wordBreak: 'break-word' }}>
            {email}
          </Typography>
          
          <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary', fontSize: { xs: '0.875rem', sm: '1rem' } }}>
            Te hemos enviado un email con los detalles de tu {paymentOrSubscription}. 
            Si no lo ves en tu bandeja de entrada, revisa la carpeta de spam o promociones.
          </Typography>

          <Box sx={{ 
            border: '2px solid',
            borderColor: 'primary.main',
            bgcolor: 'background.paper',
            p: { xs: 2, sm: 2.5 }, 
            borderRadius: 2,
            mt: 3
          }}>
            <Typography variant="body1" sx={{ color: 'text.primary', fontSize: { xs: '0.875rem', sm: '1rem' } }}>
              <strong style={{ color: 'inherit' }}>📧 Próximo paso:</strong> Haz clic en el enlace del correo para completar tu pago.
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default SuccessPage;

